export const REGION_BIKE_DELIVERY = [
  { lng: -118.2670069, lat: 34.0274462 },
  { lng: -118.2619429, lat: 34.0250632 },
  { lng: -118.2621574, lat: 34.0244941 },
  { lng: -118.2545185, lat: 34.0211862 },
  { lng: -118.2489824, lat: 34.018056 },
  { lng: -118.2452488, lat: 34.0234271 },
  { lng: -118.2442188, lat: 34.0237116 },
  { lng: -118.2412148, lat: 34.0236405 },
  { lng: -118.2368374, lat: 34.0253477 },
  { lng: -118.2334042, lat: 34.0268416 },
  { lng: -118.2298851, lat: 34.0283354 },
  { lng: -118.2261729, lat: 34.0287089 },
  { lng: -118.2295847, lat: 34.042952 },
  { lng: -118.2306147, lat: 34.0477881 },
  { lng: -118.2291985, lat: 34.0531217 },
  { lng: -118.2327604, lat: 34.0538683 },
  { lng: -118.2373953, lat: 34.053975 },
  { lng: -118.2391548, lat: 34.0548639 },
  { lng: -118.2433605, lat: 34.0575305 },
  { lng: -118.2464933, lat: 34.0601259 },
  { lng: -118.2491541, lat: 34.0630768 },
  { lng: -118.2504416, lat: 34.0642145 },
  { lng: -118.2521152, lat: 34.0626857 },
  { lng: -118.2541752, lat: 34.059166 },
  { lng: -118.2597971, lat: 34.0619747 },
  { lng: -118.2655478, lat: 34.0646055 },
  { lng: -118.2685089, lat: 34.060037 },
  { lng: -118.2682729, lat: 34.0598237 },
  { lng: -118.2698393, lat: 34.0573172 },
  { lng: -118.2690668, lat: 34.0570683 },
  { lng: -118.2721353, lat: 34.0524105 },
  { lng: -118.2756329, lat: 34.0469347 },
  { lng: -118.2767916, lat: 34.0450145 },
  { lng: -118.2784653, lat: 34.0420985 },
  { lng: -118.2791519, lat: 34.0416007 },
  { lng: -118.2835293, lat: 34.0349861 },
  { lng: -118.2744312, lat: 34.0308606 },
  { lng: -118.2670069, lat: 34.0274462 }
]
export const REGION_NO_DELIVERY1 = [

  { lng: -118.2431352, lat: 34.0458679 },
  { lng: -118.2446802, lat: 34.0464457 },
  { lng: -118.2451952, lat: 34.0455834 },
  { lng: -118.2457852, lat: 34.0448367 },
  { lng: -118.2465899, lat: 34.0454234 },
  { lng: -118.2479095, lat: 34.0439121 },
  { lng: -118.2453454, lat: 34.0422674 },
  { lng: -118.2439184, lat: 34.0442677 },
  { lng: -118.2443798, lat: 34.0444633 },
  { lng: -118.2440042, lat: 34.04513 },
  { lng: -118.2435322, lat: 34.0449789 },
  { lng: -118.2431352, lat: 34.0458679 }
]

export const REGION_NO_DELIVERY2 = [
  {lng:-118.2429957,lat:34.0458501},
  {lng:-118.2431781,lat:34.0454145},
  {lng:-118.2423627,lat:34.0451656},
  {lng:-118.2425988,lat:34.0446855},
  {lng:-118.243382,lat:34.04489},
  {lng:-118.2437789,lat:34.0442499},
  {lng:-118.2439184,lat:34.0442677},
  {lng:-118.2453454,lat:34.0422674},
  {lng:-118.2400131,lat:34.0389691},
  {lng:-118.2396913,lat:34.0437876},
  {lng:-118.2415205,lat:34.0449256},
  {lng:-118.2429957,lat:34.0458501}
]
export const REGION_CAR_DELIVERY = [
  { lng: -118.2472203, lat: 34.0805791 },
  { lng: -118.2458824, lat: 34.0831055 },
  { lng: -118.2441979, lat: 34.0848758 },
  { lng: -118.241408, lat: 34.0872652 },
  { lng: -118.2399476, lat: 34.0900534 },
  { lng: -118.2407174, lat: 34.0913652 },
  { lng: -118.2430294, lat: 34.0937757 },
  { lng: -118.2455076, lat: 34.0964647 },
  { lng: -118.2473742, lat: 34.098147 },
  { lng: -118.2499918, lat: 34.099735 },
  { lng: -118.2511072, lat: 34.1022006 },
  { lng: -118.2538532, lat: 34.1047867 },
  { lng: -118.2563638, lat: 34.1059056 },
  { lng: -118.2587886, lat: 34.1047512 },
  { lng: -118.2611274, lat: 34.1063858 },
  { lng: -118.2639168, lat: 34.1074963 },
  { lng: -118.2715988, lat: 34.1092462 },
  { lng: -118.2723353, lat: 34.1067844 },
  { lng: -118.2733722, lat: 34.1039318 },
  { lng: -118.2733861, lat: 34.1007138 },
  { lng: -118.2741862, lat: 34.0984711 },
  { lng: -118.2757004, lat: 34.0969707 },
  { lng: -118.2769356, lat: 34.095808 },
  { lng: -118.2784283, lat: 34.0956404 },
  { lng: -118.2803837, lat: 34.0925686 },
  { lng: -118.2816952, lat: 34.0923754 },
  { lng: -118.2838676, lat: 34.0909938 },
  { lng: -118.2866835, lat: 34.0909627 },
  { lng: -118.2863629, lat: 34.0763988 },
  { lng: -118.3092141, lat: 34.0763366 },
  { lng: -118.309257, lat: 34.0690671 },
  { lng: -118.3090853, lat: 34.0616725 },
  { lng: -118.3090639, lat: 34.0445877 },
  { lng: -118.3090639, lat: 34.0328238 },
  { lng: -118.300395, lat: 34.0327039 },
  { lng: -118.3002233, lat: 34.0253299 },
  { lng: -118.3002019, lat: 34.010817 },
  { lng: -118.2801818, lat: 34.0110838 },
  { lng: -118.2713198, lat: 34.0109949 },
  { lng: -118.2679724, lat: 34.0111194 },
  { lng: -118.263123, lat: 34.0110305 },
  { lng: -118.2610631, lat: 34.0109415 },
  { lng: -118.2564926, lat: 34.010906 },
  { lng: -118.2565355, lat: 34.011155 },
  { lng: -118.2521152, lat: 34.0112439 },
  { lng: -118.2518901, lat: 34.0143742 },
  { lng: -118.2461714, lat: 34.0217731 },
  { lng: -118.2429957, lat: 34.0206182 },
  { lng: -118.2381785, lat: 34.0194311 },
  { lng: -118.2352495, lat: 34.0187774 },
  { lng: -118.2299387, lat: 34.0187104 },
  { lng: -118.2286995, lat: 34.0184633 },
  { lng: -118.2278869, lat: 34.0173438 },
  { lng: -118.2263231, lat: 34.0172379 },
  { lng: -118.2253145, lat: 34.017149 },
  { lng: -118.2247353, lat: 34.0172734 },
  { lng: -118.2237911, lat: 34.0172557 },
  { lng: -118.2241021, lat: 34.0200389 },
  { lng: -118.224778, lat: 34.023 },
  { lng: -118.2254969, lat: 34.0261212 },
  { lng: -118.2261514, lat: 34.0286911 },
  { lng: -118.224349, lat: 34.029189 },
  { lng: -118.2230937, lat: 34.0299625 },
  { lng: -118.2221388, lat: 34.0315007 },
  { lng: -118.2212376, lat: 34.03303 },
  { lng: -118.2209802, lat: 34.0340168 },
  { lng: -118.2215166, lat: 34.0356304 },
  { lng: -118.2208514, lat: 34.0434676 },
  { lng: -118.2208299, lat: 34.0456012 },
  { lng: -118.2212805, lat: 34.0479303 },
  { lng: -118.2226323, lat: 34.0504993 },
  { lng: -118.2235014, lat: 34.0518549 },
  { lng: -118.2245636, lat: 34.0525527 },
  { lng: -118.2248211, lat: 34.0529438 },
  { lng: -118.226366, lat: 34.0532283 },
  { lng: -118.2261514, lat: 34.0540639 },
  { lng: -118.2255721, lat: 34.0544016 },
  { lng: -118.2318378, lat: 34.0566506 },
  { lng: -118.2318162, lat: 34.0578861 },
  { lng: -118.2321381, lat: 34.0588104 },
  { lng: -118.2335437, lat: 34.0602237 },
  { lng: -118.2351316, lat: 34.0613791 },
  { lng: -118.2341337, lat: 34.0626501 },
  { lng: -118.229617, lat: 34.0623257 },
  { lng: -118.2166458, lat: 34.0622858 },
  { lng: -118.2168603, lat: 34.0659565 },
  { lng: -118.2189564, lat: 34.0660043 },
  { lng: -118.2223399, lat: 34.0670831 },
  { lng: -118.2252548, lat: 34.0677557 },
  { lng: -118.2252267, lat: 34.0692787 },
  { lng: -118.2252234, lat: 34.0704757 },
  { lng: -118.2261733, lat: 34.0715947 },
  { lng: -118.2276167, lat: 34.069923 },
  { lng: -118.2291516, lat: 34.0688371 },
  { lng: -118.2312987, lat: 34.0675274 },
  { lng: -118.2344329, lat: 34.0655776 },
  { lng: -118.2349062, lat: 34.0655476 },
  { lng: -118.2353085, lat: 34.0655876 },
  { lng: -118.2348713, lat: 34.0676917 },
  { lng: -118.2319222, lat: 34.0697525 },
  { lng: -118.2299649, lat: 34.0711072 },
  { lng: -118.2280638, lat: 34.0715421 },
  { lng: -118.2289878, lat: 34.0723598 },
  { lng: -118.2294505, lat: 34.0722442 },
  { lng: -118.2307515, lat: 34.0751414 },
  { lng: -118.2315889, lat: 34.0770905 },
  { lng: -118.2320611, lat: 34.0776577 },
  { lng: -118.2327264, lat: 34.0779406 },
  { lng: -118.2340142, lat: 34.0785241 },
  { lng: -118.2355603, lat: 34.079312 },
  { lng: -118.2357819, lat: 34.0791635 },
  { lng: -118.2358533, lat: 34.0788373 },
  { lng: -118.2358029, lat: 34.0783625 },
  { lng: -118.2358202, lat: 34.0779996 },
  { lng: -118.2359173, lat: 34.0777937 },
  { lng: -118.2361754, lat: 34.0763792 },
  { lng: -118.2341167, lat: 34.0745099 },
  { lng: -118.2337328, lat: 34.0737395 },
  { lng: -118.2357162, lat: 34.07144 },
  { lng: -118.2377278, lat: 34.0694048 },
  { lng: -118.2380175, lat: 34.0689249 },
  { lng: -118.2387738, lat: 34.0687338 },
  { lng: -118.2392983, lat: 34.0684394 },
  { lng: -118.2398119, lat: 34.0682961 },
  { lng: -118.2408928, lat: 34.0685871 },
  { lng: -118.2413863, lat: 34.0679917 },
  { lng: -118.2413649, lat: 34.0674318 },
  { lng: -118.2433176, lat: 34.0688715 },
  { lng: -118.2440257, lat: 34.0697426 },
  { lng: -118.2456993, lat: 34.0708801 },
  { lng: -118.2470512, lat: 34.072693 },
  { lng: -118.2465093, lat: 34.0742038 },
  { lng: -118.2451977, lat: 34.0751903 },
  { lng: -118.2447135, lat: 34.075648 },
  { lng: -118.2448731, lat: 34.0760345 },
  { lng: -118.2431674, lat: 34.0780073 },
  { lng: -118.2439561, lat: 34.0790349 },
  { lng: -118.2472203, lat: 34.0805791 },
  // Check the following
  { lng: -118.2477061, lat: 34.0808089 },
  { lng: -118.2476579, lat: 34.08061 },
  { lng: -118.2473093, lat: 34.080411 },
  { lng: -118.2472203, lat: 34.0805791 },
  { lng: -118.2477061, lat: 34.0808089 }
]

export const SILVERLAKE_BIKE_DELIVERY = [
]

export const SILVERLAKE_CAR_DELIVERY = [
  { lng: -118.2949674, lat: 34.0822308 },
  { lng: -118.2874143, lat: 34.0789074 },
  { lng: -118.2754194, lat: 34.0760015 },
  { lng: -118.2673406, lat: 34.0748107 },
  { lng: -118.2609033, lat: 34.0769346 },
  { lng: -118.2522236, lat: 34.0794405 },
  { lng: -118.2510676, lat: 34.0820642 },
  { lng: -118.2498285, lat: 34.0847166 },
  { lng: -118.2438738, lat: 34.0936952 },
  { lng: -118.2467626, lat: 34.0970415 },
  { lng: -118.2499948, lat: 34.1001034 },
  { lng: -118.2515465, lat: 34.1012148 },
  { lng: -118.2542404, lat: 34.1042525 },
  { lng: -118.2671746, lat: 34.1112433 },
  { lng: -118.2692075, lat: 34.113828 },
  { lng: -118.2719337, lat: 34.1169177 },
  { lng: -118.2744073, lat: 34.1199694 },
  { lng: -118.2781258, lat: 34.1196127 },
  { lng: -118.2919768, lat: 34.1178672 },
  { lng: -118.3063896, lat: 34.1138026 },
  { lng: -118.3093492, lat: 34.1077944 },
  { lng: -118.3088977, lat: 34.0993168 },
  { lng: -118.308672, lat: 34.0946515 },
  { lng: -118.3089883, lat: 34.0918924 },
  { lng: -118.3091465, lat: 34.0887358 },
  { lng: -118.3090049, lat: 34.0835355 },
  { lng: -118.3046911, lat: 34.0836056 },
  { lng: -118.3015323, lat: 34.083569 },
  { lng: -118.2982233, lat: 34.0833724 },
  { lng: -118.2949674, lat: 34.0822308 }
];



// WEBPACK FOOTER //
// ./src/utils/googleMapRegions.js